import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";

export const useSanitize = (html: string) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'em', 'p', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'img', 'table', 'tr', 'td', 'thead', 'tbody', 'colgroup', 'br'],
    ALLOWED_ATTR: ['href', 'title', 'src', 'style', 'target', 'align', 'valign', 'width', 'height', 'border'],
    ALLOW_DATA_ATTR: false,
  });
};

const applyListClasses = (html: string) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  tempDiv.querySelectorAll("ol").forEach((el) => {
    el.classList.add("list-decimal", "list-inside");
  });

  tempDiv.querySelectorAll("ul").forEach((el) => {
    el.classList.add("list-disc", "list-inside");
  });

  tempDiv.querySelectorAll("a").forEach((el) => {
    el.classList.add("!text-indigo-400", "underline", "dark:!text-indigo-400");
  });

  return tempDiv.innerHTML;
};

export const SanitizedContent = ({ html }: { html: string }) => {
  const [sanitizedHtml, setSanitizedHtml] = useState("");

  useEffect(() => {
    const sanitized = useSanitize(html);
    const updatedHtml = applyListClasses(sanitized);
    setSanitizedHtml(updatedHtml);
  }, [html]);

  return (
    <div
      className="mt-4"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    ></div>
  );
};

export default SanitizedContent;
